import { createRoot } from 'react-dom/client'
import { useState, useEffect } from 'react'
import apiFetch from '@wordpress/api-fetch'

const rootElement = document.getElementById('rjo-podcast-root')
const templatePath = rootElement.getAttribute('data-template-path')
const podcastData = rootElement.getAttribute('data-podcast-data')
const root = createRoot(rootElement)
root.render(<PodcastListing />)
const perPage = 5

function PodcastListing(props) {

    const [articles, setArticles] = useState([])
    const [renderArticles, setRenderArticles] = useState([])
    const [offset, setOffset] = useState()


    useEffect(() => {
        const podcasts = JSON.parse(podcastData)
        setArticles(podcasts)
        
        if (window.sessionStorage.getItem('rjof-podcast-offset')) {
            const newOffset = window.sessionStorage.getItem('rjof-podcast-offset')
            setOffset(newOffset)
        } else {
            setOffset(perPage + 1)
        }
    }, [])

    useEffect(() => {
        if (!articles || !offset) return
        setRenderArticles(articles.slice(1, offset))
    }, [offset])

    function updateOffset() {
        const newOffset = offset + perPage
        setOffset(newOffset)
        window.sessionStorage.setItem('rjof-podcast-offset', newOffset)
    }

    return (<>
        {
            articles.length > 0 && 
            <article>
                <div className="podcast-details">
                    <a href={articles[0].url}><h2 className="podcast-title" dangerouslySetInnerHTML={{__html: articles[0].title}}></h2></a>
                    <span className="podcast-host">{articles[0].host}</span>
                    <span className="podcast-host-title">{articles[0].hostTitle}</span>
                </div>
                <div className="featured-podcast-details">
                    <span className="icon-span"><img src={templatePath + "/assets/images/icons/Episode Icon.png"} />Episode {articles[0].episode}</span>
                    <span className="icon-span"><img src={templatePath + "/assets/images/icons/Time Icon.png"} />{articles[0].duration}</span>
                    <div className="podcast-sources">
                        Listen on
                        <a href="https://podcasts.apple.com/us/podcast/rolling-trades-with-rjo-futures/id1815543825"><img src={`${templatePath}/assets/images/podcast/Apple Podcasts Icon.png`} /></a>
                        <a href="https://open.spotify.com/show/3tXSfgJym53cyd0EXg74vb"><img src={`${templatePath}/assets/images/podcast/Spotify Icon.png`} /></a>
                        <a href="https://music.amazon.com/podcasts/1d8ad5fd-e00a-43b3-abdb-304c2f85c973/rolling-trades-with-rjo-futures"><img src={`${templatePath}/assets/images/podcast/Amazon Podcast Icon.png`} /></a>
                        <a href="https://www.youtube.com/watch?v=yzDEDKoIgEQ&list=PLxP63WMmPzNjVmLtQKup-zotnF50EcUKe"><img src={`${templatePath}/assets/images/podcast/YouTube Icon.png`} /></a>
                    </div>
                </div>
                <div className="podcast-video">
                    <iframe width="560" height="315" src={articles[0].embed} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </article>
        }
        {
            renderArticles && renderArticles.map(article => (
                <a href={article.url} className='podcast-link'>
                    <article className='podcast'>
                        <span className='podcast-date'>{article.date}</span>
                        <img className="podcast-icon" src={templatePath + "/assets/images/RJOFutures RollingTrades Key Art.png"} />
                        <div className="podcast-details">
                            <span className="podcast-episode">Episode {article.episode}</span>
                            <h3 className="podcast-title" dangerouslySetInnerHTML={{__html: article.title}}></h3>
                            <span className="podcast-host">With {article.host}</span>
                            <span className="podcast-host-title">{article.hostTitle}</span>
                        </div>
                        <span className="podcast-meta">
                            <span className="podcast-meta-item"><img src={templatePath + "/assets/images/icons/Episode Icon.png"} />Episode {article.episode}</span>
                            <span className="podcast-meta-item"><img src={templatePath + "/assets/images/icons/Time Icon.png"} />{article.duration}</span>
                        </span>
                    </article>
                </a>
            ))
        }
        {
            articles && renderArticles.length + 1 < articles.length &&
            <div className="more-control">
                <button onClick={updateOffset}>View More</button>
            </div>
        }  
    </>
    )
}